import keyMirror from 'keymirror';

export default keyMirror({
  GET_DOCUMENTS: null,
  GET_DOCUMENT_DETAILS: null,
  SET_DOCUMENT_ACCEPTED: null,
  SET_DISCLAIMER_ACCEPTED: null,
  SET_CONFLICT_OF_INTEREST_ACCEPTED: null,
});
